import { render, staticRenderFns } from "./BaseTransactionDetailsGift.vue?vue&type=template&id=e841ea5e&"
import script from "./BaseTransactionDetailsGift.vue?vue&type=script&lang=js&"
export * from "./BaseTransactionDetailsGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports